import React, { useEffect, useState } from "react";
import TableContainer from "../../../Component/TableContainer";
import { Box, Button, Checkbox, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Switch, Typography } from "@mui/material";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { masterAPI } from "../../Masters/dataConfig";
import { axiosPrivate } from "../../../axios/axios";
import { toast } from "react-toastify";
import {
  CheckCircle,
  DeleteOutline,
  EditOffOutlined,
  EditOutlined,
  ListAlt,
  RadioButtonUncheckedOutlined,
} from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";

import { color } from "../../../StyleData/Config";
import IssueModal from "./IssueTransactionModal";
import FeedBack from "../../../Component/FeedBack";
import moment from "moment";
import { encode } from "../../../Component/JWT/Formatt";
import { fromUTC } from "../../../utils/dateUtil";

import ResponsiveDialog from "../../../Component/ResponsiveDialog";
const Issue = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const actionAllow = useSelector((state) => state.dataRed.actionsAllow);
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [create, setCreate] = useState(false);
  const [mode, setMode] = useState("");
  const [editData, setEditData] = useState({});
  const [usageStatus, setUsageStatus] = useState([]);
  const [issueId, setIssueId] = useState([]);
  const [feedBack, setFeedBack] = useState(false);
  const [confirmStatus, setConfirmStatus] = useState(false);
  const [pendingStatus, setPendingStatus] = useState(null);
  const [filterValue, setFilterValue] = useState("enableData");
  const [backUpData, setBackUpData] = useState([]);

  const [statusMenuDetail, setStatusDetail] = useState({});
  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    setIsLoading(true);
    const link = masterAPI["issue"].link;
    await axiosPrivate
      .get(`${link}`)
      .then((res) => {
        // res.data.result.sort((a, b) => {
        //   return a.code.localeCompare(b.code, undefined, {
        //     numeric: true,
        //     sensitivity: "base",
        //   });
        // });
        if (filterValue === "enableData") {
          const filterDataResult = res.data.result.filter(
            (fil) => fil.isActive,
          );
          console.log(filterDataResult, "filterData");
          setData(filterDataResult);
          setBackUpData(res.data.result);
        } else {
          setData(res.data.result);
          setBackUpData(res.data.result);
        }
        setIsLoading(false);
      })
      .catch((e) => {
        console.log(e, "issue");
        setIsLoading(false);
        setData([]);
        setBackUpData([]);
      });

    const usageLink = masterAPI["selectList"].inventoryusageStatus;
    await axiosPrivate
      .get(`${usageLink}`)
      .then((res) => {
        console.log(res);
        setUsageStatus(res.data);
        setIsLoading(false);
      })
      .catch((e) => {
        console.log(e, "error");
        setIsLoading(false);
      });
  };

  const handleButtonNew = () => {
    setMode("Create");
    setCreate(true);
  };
  const handleCreateClose = () => {
    setMode("");
    setCreate(false);
    getData();
  };

  const handleEdit = (data) => {
    setEditData(data);
    setMode("Edit");
    setCreate(true);
  };

  // const handleDelete = (id) => {
  //   const deleteLink = masterAPI["issue"].delete;
  //   axiosPrivate
  //     .delete(`${deleteLink}/${id}`)
  //     .then((res) => {
  //       console.log(res.data);
  //       getData();
  //     })
  //     .catch((e) => {
  //       console.log(e, "delete receipt");
  //     });
  // };

  const handleDelete = async (e, id) => {
    const enableLink = masterAPI["issue"].enable;
    const disableLink = masterAPI["issue"].disable;
    if (e.target.checked) {
      await axiosPrivate
        .put(`${enableLink}/${id}`)
        .then((res) => {
          console.log(res.data);
          getData();
        })
        .catch((e) => {
          console.log(e, "enable issue");
        });
    } else {
      await axiosPrivate
        .put(`${disableLink}/${id}`)
        .then((res) => {
          console.log(res.data);
          getData();
        })
        .catch((e) => {
          console.log(e, "disable issue");
        });
    }
  };

  const handleCheck = (e, value) => {
    if (e.target.checked) {
      setIssueId([...issueId, value]);
    } else {
      const filIss = issueId.filter((fil) => fil !== value);
      setIssueId(filIss);
    }
  };

  const columns = [
    {
      accessor: "id",
      disableFilters: true,
      Cell: ({ cell }) => {
        return (
          <Box sx={{ width: color.checkBoxWidth }}>
            <Checkbox
              // icon={<RadioButtonUncheckedOutlined />}
              // checkedIcon={<CheckCircle />}
              checked={issueId.includes(cell.value)}
              onClick={(e) => {
                handleCheck(e, cell.value);
              }}
            />
          </Box>
        );
      },
    },
    {
      Header: "Code",
      accessor: "code",
      Cell: ({ cell }) => {
        return (
          <Link
            to={`/issue/issueItem?id=${encode(cell.row.original.id)}`}
            onClick={() => {
              dispatch({
                type: "storeDisplayListName",
                payload: { name: "issueItem", data: cell.row.original },
              });
            }}
            style={{
              color: "#0d6efd",
              textDecorationLine: "underline",
              fontWeight: 800,
            }}
          >
            {cell.value}
          </Link>
        );
      },
    },
    {
      Header: "Work Order",
      accessor: "workOrderName",
      // disableFilters: true,
    },
    {
      Header: "Asset",
      accessor: "assetName",
      // disableFilters: true,
    },
    {
      Header: "GL Credit Account",
      accessor: "glCreditAccount",
    },
    {
      Header: "GL Debit Account",
      accessor: "glDebitAccount",
    },
    {
      Header: "Status",
      accessor: "status",
    },
    {
      Header: "Issued Date",
      accessor: "issuedDate",
      Cell: ({ cell }) => {
        return fromUTC(cell.value).tzString;
      },
    },
    {
      Header: "Actions",
      Cell: ({ cell }) => {
        // console.log(cell)
        return (
          <Box sx={{ whiteSpace: "nowrap" }}>
            <IconButton
              disabled={
                !actionAllow.edit ||
                cell.row.original.status === "Completed" ||
                cell.row.original.status === "Cancelled"
              }
              onClick={() => {
                handleEdit(cell.row.original);
              }}
            >
              <EditOutlined
                sx={{
                  fontSize: color.masterEditDelButton,
                  color:
                    actionAllow.edit &&
                    cell.row.original.status !== "Completed" &&
                    cell.row.original.status !== "Cancelled"
                      ? color.masterEditDelButtonColor
                      : "default",
                }}
              />
            </IconButton>
            {/* <IconButton>
              <ListAlt
                onClick={() => {
                 navigate(`/issue/issueItem?id=${cell.row.original.id}`)
                }}
                sx={{
                  fontSize: color.masterEditDelButton,
                  color: color.masterEditDelButtonColor,
                }}
              />
            </IconButton> */}
            {/* <IconButton
            disabled={!actionAllow.delete}
            onClick={() => {
              handleDelete(cell.row.original.id);
            }}>
              <DeleteOutline
              
                sx={{
                  fontSize: color.masterEditDelButton,
                  color:actionAllow.delete? color.masterEditDelButtonColor:"default",
                }}
              />
            </IconButton> */}
            <Switch
              disabled={!actionAllow.delete}
              checked={cell.row.original.isActive}
              onChange={(e) => {
                handleDelete(e, cell.row.original.id);
              }}
            />
          </Box>
        );
      },
    },
  ];

  const menuStatusHandle = (value) => {
    console.log(value);
    setStatusDetail(value);
    setPendingStatus(value);
    setConfirmStatus(true);
  };

  const handleConfirmOk = () => {
    setConfirmStatus(false);
    if (pendingStatus.value === "Cancelled") {
      setFeedBack(true);
    } else {
      handleMenuSelect(pendingStatus, "");
    }
  };

  const handleMenuSelect = async (menuData, reason) => {
    setFeedBack(false);
    const putData = issueId.map((id) => ({
      id,
      status: menuData.value,
      reasontoCancel: reason,
    }));
    console.log(putData);
    const statusLink = masterAPI["issue"].bulkUpdateStatus;
    await axiosPrivate
      .put(`${statusLink}`, putData)
      .then((res) => {
        console.log(res);
        getData();
        setIssueId([]);
      })
      .catch((e) => {
        console.log(e, "error");
      });
  };

  const handleChangeFilter = (e) => {
    if (e === "showAll") {
      setData(backUpData);
    } else {
      const filterDataResult = backUpData.filter((fil) => fil.isActive);

      setData(filterDataResult);
    }
    setFilterValue(e);
  };

  return (
    <>
      <Box>
        <Typography
          sx={{
            color: color.masterPageTitleColor,
            fontSize: color.masterPageTitleFontSize,
            fontWeight: color.masterPageTitleFontWeight,
            mb: color.masterPageTitlemd,
          }}
        >
          {masterAPI["issue"].title}
        </Typography>
      </Box>

      <TableContainer
        columns={columns}
        data={data}
        buttonNew={handleButtonNew}
        loading={isLoading}
        statusList={usageStatus}
        menuStatusHandle={menuStatusHandle}
        buttonDisable={!actionAllow.create}
        changeStatusOption={issueId.length > 0}
        filterValue={filterValue}
        handleChange={handleChangeFilter}
        filterShow={true}
      />

      <ResponsiveDialog
        open={create}
        onClose={handleCreateClose}
        maxWidth={"xl"}
        children={
          <IssueModal
            handleCloseClick={handleCreateClose}
            mode={mode}
            editData={editData}
          />
        }
      />
      <ResponsiveDialog
        open={confirmStatus}
        onClose={() => setConfirmStatus(false)}
        maxWidth={"xs"}
        fullWidth
      >
        <DialogTitle>Confirm Status Change</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to change the status of all {issueId.length}{" "}
            selected item(s) to <strong>{pendingStatus?.text}</strong>? Note:
            Each issue may contain multiple parts — all parts inside the
            selected issues will also be completed.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmStatus(false)} color="inherit">
            Cancel
          </Button>
          <Button onClick={handleConfirmOk} variant="contained" color="primary">
            OK
          </Button>
        </DialogActions>
      </ResponsiveDialog>

      <ResponsiveDialog
        open={feedBack}
        onClose={() => setFeedBack(false)}
        maxWidth={"lg"}
        children={
          <FeedBack
            handleCloseClick={(e) => handleMenuSelect(statusMenuDetail, e)}
            onCancel={() => {
              setFeedBack(false);
            }}
          />
        }
      />
    </>
  );
};

export default Issue;
